module.exports = __webpack_public_path__ + "img/lb2.889e6559.jpg";